export function saveAllClick() {
    const saveBtn = document.getElementById('save-scripts-btn');
    if (saveBtn) {
        if (!document.querySelector('.transform-view__cell-edit-popup')) {
            saveBtn.click();
        }
    }
}